import FacilitatorParticipants from '@/src/components/game/FacilitatorParticipants/FacilitatorParticipants';
import React from 'react';

export const JamEventFacilitatorParticipantsPage: React.FC = () => {
  return <FacilitatorParticipants />;
};
